// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BnQYt","top":"styles_top__1DPrf","left":"styles_left__KcDMu","description":"styles_description__34qFS"};